/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CostcoProduct } from './CostcoProduct';
import {
    CostcoProductFromJSON,
    CostcoProductFromJSONTyped,
    CostcoProductToJSON,
} from './CostcoProduct';

/**
 * コストコ商品の仕入れた商品
 * @export
 * @interface StockupItem
 */
export interface StockupItem {
    /**
     * 
     * @type {string}
     * @memberof StockupItem
     */
    id: string;
    /**
     * 
     * @type {CostcoProduct}
     * @memberof StockupItem
     */
    costcoProduct: CostcoProduct;
    /**
     * 
     * @type {number}
     * @memberof StockupItem
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof StockupItem
     */
    status: StockupItemStatusEnum;
}


/**
 * @export
 */
export const StockupItemStatusEnum = {
    Reserved: 'reserved',
    Stocked: 'stocked',
    OutOfStock: 'out_of_stock'
} as const;
export type StockupItemStatusEnum = typeof StockupItemStatusEnum[keyof typeof StockupItemStatusEnum];


/**
 * Check if a given object implements the StockupItem interface.
 */
export function instanceOfStockupItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "costcoProduct" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function StockupItemFromJSON(json: any): StockupItem {
    return StockupItemFromJSONTyped(json, false);
}

export function StockupItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockupItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'costcoProduct': CostcoProductFromJSON(json['costco_product']),
        'quantity': json['quantity'],
        'status': json['status'],
    };
}

export function StockupItemToJSON(value?: StockupItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'costco_product': CostcoProductToJSON(value.costcoProduct),
        'quantity': value.quantity,
        'status': value.status,
    };
}

